export type RateOrFeeType =
    | 'PAYT'
    | 'Volume-Based Carts'
    | 'Fee for an additional cart'
    | 'Fixed Fee'
    | 'No Fee'
    | 'Other';

export const RATE_OR_FEE_TYPES: { label: string; value: RateOrFeeType }[] = [
  { label: 'PAYT', value: 'PAYT' },
  { label: 'Volume-Based Carts', value: 'Volume-Based Carts' },
  { label: 'Fee for an additional cart', value: 'Fee for an additional cart' },
  { label: 'Fixed Fee', value: 'Fixed Fee' },
  { label: 'No Fee', value: 'No Fee' },
  { label: 'Other', value: 'Other' },
];

export const RATE_OR_FEE_PERIOD_VALUES = [
  'Monthly',
  'Quarterly',
  'Annually',
    'Other',
    'Not Applicable'
];

export type RateOrFeePeriod = typeof RATE_OR_FEE_PERIOD_VALUES[number];

export const RATE_OR_FEE_PERIODS: { label: string; value: RateOrFeePeriod }[] =
    RATE_OR_FEE_PERIOD_VALUES.map(v => ({ label: v, value: v }));
